import { currentPage, initNewSection } from '../common/layout';
import { banners, hitPageView} from '../common/utils/fn';
import { getM1FindVehicleEu, getM1FindVehicleUs, getM1FindVehicleByType } from '../common/shop/m1-find-vehicle-widget-loader';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
  
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  getM1FindVehicleEu().then((api) => {
    api.m1FindVehicleEu();
  });
  getM1FindVehicleUs().then((api) => {
    api.m1FindVehicleUs();
  });
  getM1FindVehicleByType().then((api) => {
    api.m1FindVehicleByType();
  });
};
currentPage.pageLoadMore = ($html, $btnBox) => {
  //$btnBox.replaceWith($html);
  initNewSection($html);
  // hybridLazyLoad();
  banners($html);

  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  hitPageView(document.location.pathname);
};
